/**
 * DASHBOARD-REPARTION.ROUTE
 * Results by inequalities : dispersion of the scores inside a population
 * Internal : only for the people connected as supervisor, on an account that has the module "inequalities"
 */

import { connect } from "react-redux"
import { Navigate } from "react-router-dom"
import { Session } from "@/redux/_session.types"
import NavDashboard from "@/nav/nav.dashboard"
import DashboardInequalitiesWidget from "@/widgets/dashboard-inequalities.widget"

interface StateProps {
  _session: Session
}

function DashboardRepartitionRoute(props: StateProps) {
  //The address is not hidden : the access is checked here
  if (!props._session.modules.survey.inequalities || !props._session.connectedAsSupervisor) {
    return <Navigate to="/dashboard/overview" replace />
  }

  return (
    <NavDashboard title="survey_repartition" hideOptions>
      <DashboardInequalitiesWidget />
    </NavDashboard>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(DashboardRepartitionRoute)
